<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-1">
<h1>1</h1>
<p style="text-indent: 0em">Soft melodies of uncertainty call out to me</p>
<p style="text-indent: 0em">The notes grow sharper and more hostile as the orchestra plays on</p>
<p style="text-indent: 0em">I don’t bother covering my ears. The symphony exists solely in my head</p>
<p style="text-indent: 0em">Days stretch to weeks that stretch to months</p>
<p style="text-indent: 0em">And all I can sense is a dormant lack of identity.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?26080e66